<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户ID" prop="userId">
                <a-input v-model="queryParam.userId" placeholder="请输入用户id" allow-clear/>
              </a-form-item>
            </a-col>
            <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
            <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="是否会员" prop="sex">
                <a-select placeholder="请选择是否会员" v-model="queryParam.isVip" style="width: 100%" allow-clear>
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="8" :sm="24">
              <a-form-item label="上级ID" prop="leadId">
                <a-input v-model="queryParam.leadId" placeholder="请输入上级用户id" allow-clear/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['video:video:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :sexOptions="dict.type.sys_user_sex"
        :isNoticeOptions="dict.type.sys_notice_status"
        :statusOptions="dict.type.sys_enable_disable"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex"/>
        </span>
        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
        </span>


        <span slot="diamond" slot-scope="text, record">
          <a-input-number :min="0" :step="0"  v-model="record.diamond" @keyup.enter="editDiamond(record)" />
        </span>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        
        <template slot="leadId" slot-scope="text, record">
          <span>{{ text == null ? '无' : text }}</span>
        </template>
        
        <template slot="distQuality" slot-scope="text, record">
          <span>{{ text == 1 ? '正式' : '预备' }}</span>
        </template>

      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
  
</template>

<script>
import { pageUser, listUser, delUser,editLevel,editVipTime,editDiamond } from '@/api/user/info'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {editType} from "@/api/video/video";
import Vue from "vue";
// import moment from "moment";
import DisMoney from "@/views/user/distribution/modules/DisMoney";

export default {
  name: 'disUser',
  components: {
    DisMoney,
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: true,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        leadId: null,
        userId: null,
        mobile: null,
        email: null,
        isVip: null,
        nickname: null,
        sex: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          // ellipsis: true,,
          customRender: (text, record, index) => index + 1,
          width: '120',
          align: 'center'
        },
        {
          title: '用户ID',
          dataIndex: 'id',
          width: '120',
          align: 'center'
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          width: '120',
          align: 'center'
        },
        {
          title: '分销等级',
          dataIndex: 'gradeLevel',
          width: '120',
          align: 'center'
        },
        {
          title: '上级ID',
          dataIndex: 'leadId',
          width: '120',
          align: 'center',
          scopedSlots: { customRender: 'leadId' }
        },
        {
          title: '分销金额',
          dataIndex: 'distmoney',
          width: '120',
          align: 'center'
        },
        {
          title: '分销人数',
          dataIndex: 'childNum',
          width: '120',
          align: 'center'
        },
        {
          title: '成为分销资格',
          dataIndex: 'distQuality',
          width: '120',
          align: 'center',
          scopedSlots: { customRender: 'distQuality' }
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {

    editLevel(record) {
      editLevel(record).then(response => {
        this.$message.success(
          '操作成功',
          3
        )
      })
    },

    editDiamond(record) {
      editDiamond(record).then(response => {
        this.$message.success(
          '操作成功',
          3
        )
      })
    },

    /** 查询用户信息列表 */
    getList () {
      this.loading = true
     pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        // console.log("data: ", this.list)
        this.total = response.data.total
        this.loading = false
      })
    },

    editVipTime(record) {
      if (moment.isMoment(record.vipOverTime)) {
        record.vipOverTime = record.vipOverTime.format('YYYY-MM-DD')
      }
      editVipTime(record).then(response => {
        this.$message.success(
          '操作成功',
          3
        )
        this.getList()
      })

    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        mobile: undefined,
        email: undefined,
        nickname: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('account/accounts/distexport', {
            ...that.queryParam
          }, `用户分销信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
